var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSoilChair(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 142,
    viewBox: "0 0 143 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1545_9249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.738 70.9999C140.738 109.435 109.593 140.58 71.1581 140.58C32.7235 140.58 1.57812 109.435 1.57812 70.9999C1.57812 32.5653 32.7235 1.41992 71.1581 1.41992C109.593 1.41992 140.738 32.5653 140.738 70.9999Z",
    fill: "url(#paint0_linear_1545_9249)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1545_9249)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.258 46.1794C103.284 46.3125 103.308 46.4299 103.341 46.5139C103.407 46.679 102.875 51.6149 102.238 57.5294C101.327 65.9774 100.201 76.422 100.295 77.8127C100.295 79.8165 99.0931 102.339 98.6924 109.472C98.6122 110.674 97.6103 111.636 96.4081 111.636H95.8871C94.6047 111.636 93.6028 110.594 93.6028 109.352C93.6028 103.661 93.5227 88.9938 92.6811 83.9843C91.9597 79.8566 89.996 78.8547 87.5114 78.7746L86.269 100.014C86.1889 101.217 85.187 102.179 83.9847 102.179C82.7825 102.179 81.7806 101.257 81.7004 100.055L80.3379 79.2555C78.483 79.3779 77.3999 79.5234 76.3945 79.6583C75.0974 79.8325 73.9297 79.9892 71.4011 80.057H71.3209C68.653 79.9855 67.401 79.8291 65.9405 79.6466C64.944 79.5221 63.8504 79.3855 62.1437 79.2555L60.7811 100.055C60.701 101.257 59.6991 102.179 58.4968 102.179C57.2946 102.179 56.2927 101.217 56.2125 100.014L54.9702 78.7746C52.4855 78.8948 50.5218 79.8566 49.8005 83.9843C48.9188 88.9938 48.8788 103.661 48.8788 109.352C48.8788 110.634 47.8368 111.636 46.5945 111.636H46.0735C44.8712 111.636 43.8693 110.674 43.7892 109.472C43.6828 107.367 43.4996 103.922 43.2942 100.06C42.8035 90.8334 42.1862 79.2252 42.1862 77.8127C42.1862 76.5596 41.2406 67.9554 40.3756 60.0847C39.6085 53.1051 38.9048 46.7023 38.9802 46.5139C39.0138 46.4299 39.0368 46.3125 39.0629 46.1794C39.1614 45.6771 39.3039 44.951 40.2225 44.951H43.8293C43.8293 44.951 45.1518 44.0293 47.6364 37.0562C50.0291 30.3026 58.9624 30.3499 61.3742 30.3626C61.4669 30.3631 61.55 30.3636 61.6227 30.3636H80.9791C81.0521 30.3636 81.1351 30.3631 81.2276 30.3626C83.6216 30.3499 92.2925 30.3036 94.6848 37.0562C97.1695 44.0293 98.492 44.951 98.492 44.951H102.099C103.017 44.951 103.16 45.6771 103.258 46.1794ZM58.2163 67.8741L59.9395 40.4225C60.0998 38.3386 59.0579 36.3749 56.2526 37.4569C54.4709 38.1442 53.5298 40.3187 52.5361 42.6149C51.9652 43.934 51.377 45.2933 50.602 46.4338C48.999 48.9585 48.7585 49.0387 47.5563 49.239C44.2701 49.3192 44.751 51.884 44.751 51.884C46.4342 69.6374 53.0065 68.7958 53.0065 68.7958H56.4931C58.2564 68.8359 58.2163 67.8741 58.2163 67.8741ZM68.0348 57.9354C68.3554 57.9354 68.5958 57.6949 68.5958 57.3743V42.1457C68.5958 41.8251 68.3554 41.5847 68.0348 41.5847C67.7142 41.5847 67.4737 41.8251 67.4737 42.1457V57.3743C67.4737 57.6949 67.7142 57.9354 68.0348 57.9354ZM74.6071 57.9354C74.9277 57.9354 75.1682 57.6949 75.1682 57.3743V42.1457C75.1682 41.8251 74.9277 41.5847 74.6071 41.5847C74.2865 41.5847 74.0461 41.8251 74.0461 42.1457V57.3743C74.0461 57.6949 74.2865 57.9354 74.6071 57.9354ZM89.3148 68.7958C89.3148 68.7958 95.9272 69.5973 97.5703 51.884C97.5703 51.884 98.0512 49.3192 94.765 49.239C93.5627 49.0387 93.3223 48.9585 91.7193 46.4338C90.8394 45.1388 90.3996 43.5619 89.9869 42.0819C89.4034 39.9894 88.874 38.0907 87.2308 37.4569C84.4256 36.3749 83.3435 38.3786 83.5038 40.4225L85.2271 67.8741C85.2271 67.8741 85.187 68.8359 86.9503 68.7958H89.3148ZM71.2811 68.8359C79.5366 68.8359 80.258 68.6756 80.258 68.4752C80.258 68.2748 79.5767 68.1145 71.2811 68.1145C63.0256 68.1145 62.0237 68.2748 62.0237 68.4752C62.0237 68.6756 63.0256 68.8359 71.2811 68.8359Z",
    fill: "#C8A262"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1545_9249)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.1591,
    cy: 70.9999,
    r: 61.3872,
    stroke: "#C8A262",
    strokeWidth: 4.07895
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1545_9249",
    x: 0.15625,
    y: 0,
    width: 142,
    height: 143.632,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9249"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1545_9249",
    x: 38.9746,
    y: 30.3613,
    width: 64.3711,
    height: 82.9065,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9249"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1545_9249",
    x: 7.73242,
    y: 7.57324,
    width: 126.854,
    height: 128.485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9249"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1545_9249",
    x1: 22.8781,
    y1: 16.5666,
    x2: 124.408,
    y2: 115.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2B589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71136,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1B088"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSoilChair);
export default __webpack_public_path__ + "static/media/IconSoilChair.6961077e7eb219b5bb7f085b192f8c9b.svg";
export { ForwardRef as ReactComponent };